import { getData } from "@/utils/fetch";
import debounce from "debounce-promise";
import { defineStore } from "pinia";

let debouncedFetch = debounce(getData, 500);

export const useOrderStore = defineStore({
  id: "order",
  state: () => ({
    orders: {},
    countByDate: {},
  }),
  getters: {
    getDataOrder(state) {
      return state.orders.data;
    },
  },
  actions: {
    async getAllOrder(params) {
      this.orders = { loading: true };

      const dataparams = {
        limit: params?.limit || 50,
        offset: params?.offset || 0,
        order: params?.order || "scene_date",
        ordertype: params?.ordertype || "ASC",
        scenedate1: params?.scenedate1,
        scenedate2: params?.scenedate2,
        orderdate1: params?.orderdate1,
        orderdate2: params?.orderdate2,
        status: params?.status,
        q: params?.q,
      };

      try {
        const result = await debouncedFetch("order", dataparams);
        this.orders = { ...result.data };
      } catch (error) {
        console.log(error);
        this.orders = { error };
      }
    },
    async getCountByDate(params) {
      this.countByDate = { loading: true };

      const dataparams = {
        year: params?.year,
        month: params?.month,
      };
      try {
        const result = await debouncedFetch("order/count/bydate", dataparams);
        this.countByDate = { ...result.data };
      } catch (error) {
        console.log(error);
        this.countByDate = { error };
      }
    },
  },
});
